import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  InputGroup,
  InputLeftElement,
  IconButton,
  Image,
  HStack,
  Spinner,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon, RepeatIcon } from "@chakra-ui/icons";
import { useForm } from "react-hook-form";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getCaptcha, login } from "../../services/authService";
import { useAuth } from "../../contexts/AuthContext";

export default function SignIn() {

  
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // ====== بخش جدید: کپچا ======
  const [captchaSvg, setCaptchaSvg] = useState(""); 
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaToken,setCaptchaToken]=useState('')


  // دریافت کپچا از سرور
  const fetchCaptcha = async () => {
  setCaptchaLoading(true);
  try {
    const svgText = await getCaptcha();
    setCaptchaSvg(svgText.data);
    setCaptchaToken(svgText.token)

    
  } catch (err) {
    toast.error("دریافت کپچا ناموفق بود");
  } finally {
    setCaptchaLoading(false);
  }
};

const location=useLocation();

    const { isAuthenticated } = useAuth();

  // دریافت کپچا هنگام بارگذاری اولیه
  useEffect(() => {
   
    

    if (isAuthenticated) {
      navigate('/dashboard')
  }
  else{
     fetchCaptcha();
  }
  }, []);
  // ====== پایان بخش کپچا ======

  // متغیرهای PWA
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  const boxBg = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.500");
  const textColor = useColorModeValue("gray.800", "white");

  React.useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handlePWAInstall = async () => {
    // (همان کد قبلی)
    if (!deferredPrompt) {
      toast.info("اپ از قبل نصب شده یا قابل نصب نیست");
      return;
    }
    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        toast.success("اپ با موفقیت نصب شد!");
        setShowInstallButton(false);
      } else {
        toast.info("نصب اپ لغو شد");
      }
      setDeferredPrompt(null);
    } catch (error) {
      console.error('خطا در نصب PWA:', error);
      toast.error("خطا در نصب اپ");
    }
  };

  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    setError("");

    // اعتبارسنجی خالی نبودن کپچا
    if (!captchaInput.trim()) {
      setError("لطفاً متن کپچا را وارد کنید");
      setIsLoading(false);
      return;
    }

    try {
      // ارسال اطلاعات با کپچا
      const result = await login({
        phone: data.phone,
        password: data.password,
        captchaInput,
        captchaToken // <-- ارسال پاسخ کپچا
      });

      authLogin(result.data.user, result.data.token);

      if (result.data.user.role === "admin") {
        navigate("/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      setError(error.message || "خطا در ورود");
      toast.error(error.message || "خطا در ورود");
      // در صورت خطا، کپچای جدید بگیرید و فیلد را خالی کنید
      fetchCaptcha();
      setCaptchaInput("");
    } finally {
      setIsLoading(false);
    }
  };

   

  return (


    <Flex minH="100vh" align="center" justify="center" bg={useColorModeValue("gray.50", "gray.900")}>
      <Stack spacing={8} mx="auto" maxW="lg" py={12} px={6}>
        <Stack align="center">
          <Image
            src="/logo.png"
            alt="لوگو مرکز مشاوره نارون سبز"
            boxSize="120px"
            objectFit="contain"
            mb={4}
          />
          <Heading fontSize="xl" textAlign="center">
            ورود به سامانه مرکز مشاوره نارون سبز
          </Heading>
        </Stack>

        <Box
          rounded="lg"
          bg={useColorModeValue("white", "gray.700")}
          boxShadow="lg"
          p={8}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={4}>
              {error && (
                <Alert status="error">
                  <AlertIcon />
                  {error}
                </Alert>
              )}

              <FormControl id="phone" isInvalid={errors.phone}>
                <FormLabel>شماره تلفن</FormLabel>
                <Input
                  type="tel"
                  {...register("phone", {
                    required: "شماره تلفن الزامی است",
                    pattern: {
                      value: /^(\+98|0)?9\d{9}$/,
                      message: "شماره تلفن معتبر نیست (مثال: 09123456789)",
                    },
                  })}
                  placeholder="09123456789"
                  dir="ltr"
                />
                {errors.phone && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {errors.phone.message}
                  </Text>
                )}
              </FormControl>

              <FormControl id="password" isInvalid={errors.password}>
                <FormLabel>رمز عبور</FormLabel>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    {...register("password", {
                      required: "رمز عبور الزامی است",
                      minLength: {
                        value: 6,
                        message: "رمز عبور باید حداقل ۶ کاراکتر باشد",
                      },
                    })}
                    placeholder="رمز عبور خود را وارد کنید"
                  />
                  <InputLeftElement>
                    <IconButton
                      aria-label={showPassword ? "مخفی کردن رمز عبور" : "نمایش رمز عبور"}
                      icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                      onClick={() => setShowPassword(!showPassword)}
                      variant="ghost"
                      size="sm"
                    />
                  </InputLeftElement>
                </InputGroup>
                {errors.password && (
                  <Text color="red.500" fontSize="sm" mt={1}>
                    {errors.password.message}
                  </Text>
                )}
              </FormControl>

              {/* ====== بخش جدید: کپچا ====== */}
              <FormControl id="captcha">
                <FormLabel>کد امنیتی</FormLabel>
                <HStack spacing={2} align="start">
                  <Box
                    border="1px solid"
                    borderColor={useColorModeValue("gray.200", "gray.500")}
                    borderRadius="md"
                    p={2}
                    bg="gray.50"
                    height="60px"
                    minW="160px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    overflow="hidden"
                    dangerouslySetInnerHTML={{ __html: captchaSvg }}
                  />
                  <IconButton
                    aria-label="تازه‌سازی کپچا"
                    icon={captchaLoading ? <Spinner size="sm" /> : <RepeatIcon />}
                    onClick={fetchCaptcha}
                    isLoading={captchaLoading}
                    variant="outline"
                    colorScheme="blue"
                    size="md"
                  />
                </HStack>
                <Input
                  mt={2}
                  placeholder="متن تصویر را وارد کنید"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  autoComplete="off"
                />
              </FormControl>
              {/* ====== پایان بخش کپچا ====== */}

              <Button
                type="submit"
                colorScheme="blue"
                size="lg"
                fontSize="md"
                isLoading={isLoading}
                loadingText="در حال ورود..."
              >
                ورود
              </Button>

              <Button
                variant="link"
                color="blue.500"
                fontSize="sm"
                onClick={() => window.location.href = '/#/auth/forgot-password'}
                _hover={{ textDecoration: 'underline' }}
              >
                فراموشی رمز عبور؟
              </Button>

              {showInstallButton && (
                <Box
                  bg={boxBg}
                  p={4}
                  borderRadius="xl"
                  border="1px solid"
                  borderColor={borderColor}
                  boxShadow="sm"
                  _hover={{
                    boxShadow: "md",
                    transform: "translateY(-1px)",
                    transition: "all 0.2s"
                  }}
                >
                  {/* ... کد PWA مشابه قبل */}
                </Box>
              )}

              <Button
                variant="outline"
                onClick={() => navigate("/welcome")}
                size="md"
                w="full"
              >
                بازگشت به صفحه اول
              </Button>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  )}
